import { render, staticRenderFns } from "./TaxSavingsWidget.vue?vue&type=template&id=24342451&scoped=true"
import script from "./TaxSavingsWidget.vue?vue&type=script&lang=ts"
export * from "./TaxSavingsWidget.vue?vue&type=script&lang=ts"
import style0 from "./TaxSavingsWidget.vue?vue&type=style&index=0&id=24342451&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24342451",
  null
  
)

export default component.exports